import ParameterErrors from '../errors/ParameterErrors';
import SiteJsonUnitPlotRoom from './SiteJsonUnitPlotRoom';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitPlotRooms{
	constructor(props){
		const {list}=props;
		if(list === undefined || list === null)
			throwNotProvided('list');
		if(!Array.isArray(list))
			throwNotOfType('list', 'Array');
		this._list = list;
		this.toJSON= this.toJSON.bind(this);
	}
	getArray(){
		return this._list;
	}
	toJSON(){
		return this._list.map(room=>room.toJSON());
	}
	get allImages(){
		let images =[];
		this._list.forEach(room=>images = images.concat(room.images));
		return images;
	}
	static fromJSON(jArraySites, getParentPlot){
		if(getParentPlot === undefined || getParentPlot === null)
			throwNotProvided('getParentPlot');
		const rooms=[];
		for(var i=0; i<jArraySites.length; i++){
			const jObjectSite = jArraySites[i];
			rooms.push(SiteJsonUnitPlotRoom.fromJSON(jObjectSite, getParentPlot));
		}
		return new SiteJsonUnitPlotRooms({list:rooms});
	}
}